module.exports = __webpack_public_path__ + "img/home-article-1.2987a59b.jpg";